export const environment = {
  production: false,
  environmentFile: 'default',
  mapboxApiKey: 'pk.eyJ1Ijoic2VidWJ1IiwiYSI6ImNqZGxsdm85czA1N2Uyd3BjOWdsOGFnc3IifQ.2oxeuQlVi1zVoY_39M8GJA',
  interactionGatewayUrl: '/',
  get interactionGatewayProxyUrl(): String {
    return this.interactionGatewayUrl + 'proxy/';
  },
  get forecastServiceUrl(): String {
    return this.interactionGatewayProxyUrl + 'forecast/frontend/';
  },
  aymoMessageOrigin: 'https://www.aymo.ch/',
  aymoMapUrlRegex: /^http[s]?:\/\/map[-a-z]*.gotthard.apgsga.ch\/[a-z]{2}\/$/,
};
